module.exports = __webpack_public_path__ + "static/psilocybin-trans-white-01bca2b505edf8548957c36f7d0a43c7.png";